import { IReferralsConnectionCreate, IReferralsConnectionUpdate } from './connection.interfaces';

export class CreateConnection {
  public static type: string = '[Http] CreateConnection';
  constructor(public payload: IReferralsConnectionCreate) {}
}

export class LoadConnections {
  public static type: string = '[Http] LoadConnections';
  constructor(
    public payload?: {
      params?: { q?: string; page?: number; limit?: number };
      clearStore?: boolean;
    },
  ) {}
}
export class LoadConnection {
  public static type: string = '[Http] LoadConnection';
  constructor(public payload: { id: number; active: true }) {}
}

export class UpdateConnection {
  public static type: string = '[Http] UpdateConnection';
  constructor(public payload: IReferralsConnectionUpdate) {}
}

export class DeleteConnection {
  public static type: string = '[Http] DeleteConnection';
  constructor(public payload: { id: number }) {}
}
